import { useCallback } from 'react';

import { useAnalytics } from '~/analytics';
import { useTrackOncePerId } from '~/hooks/useTrackOncePerId';

/**
 * Fires `invoice_opened` once for each invoice the calling surface opens. See
 * {@link useTrackOncePerId} for why the guard is there.
 *
 * Shared rather than kept in the route: the Work Queue dialog hosts `InvoiceDetailPage`
 * directly and never passes through `/spending/:invoiceId`, so opens from the queue, the
 * consultant's main surface, went untracked entirely.
 */
export function useTrackInvoiceOpened(invoiceId: string | null | undefined): void {
  const { track } = useAnalytics();

  useTrackOncePerId(
    invoiceId,
    useCallback((id: string) => track('invoice_opened', { invoice_id: id }), [track]),
  );
}
